import {defineStore} from "pinia";
import Admin from "@/types/Admin";

interface State {
    user: Admin | null;
}

export const useMainStore = defineStore("main", {
    state: (): State => ({
        user: null
    })
});